import React from 'react';

function Address({
  addresses = [],
  loading = false,
  selectedAddress,
  showAllAddresses = false,
  handleAddNewAddress,
  handleAddressSelection,
  toggleShowAllAddresses,
}) {
  return (
    <div className="mb-8 max-w-7xl mx-auto">
      <div className="mb-1">
        <button
          onClick={handleAddNewAddress}
          className="text-blue-500 hover:text-blue-700 font-medium text-lg focus:outline-none transition duration-200"
        >
          + Add a New Address
        </button>
      </div>
      {loading ? (
        <p className="text-gray-600">Loading addresses...</p>
      ) : addresses.length > 0 ? (
        <div className="space-y-4 w-[63%]">
          {(showAllAddresses ? addresses : addresses.slice(0, 2)).map((address) => (
            <div
              key={address._id}
              className="p-2 border border-gray-300 rounded-lg shadow-lg"
            >
              <div className="flex items-center mb-1">
                <input
                  type="radio"
                  name="address"
                  value={address._id}
                  checked={selectedAddress === address._id}
                  onChange={() => handleAddressSelection(address)}
                  className="mr-4 cursor-pointer focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none"
                />
                <span className="font-semibold text-lg text-gray-800">Select address</span>
              </div>
              <div className="space-y-1 text-gray-700">
                <span className="text-sm">{address.mobileNumber},</span>
                <span className="text-sm">
                  {address.houseNumberOrApartment}, {address.areaOrStreet}
                </span>
                <span className="text-sm">
                  {address.cityOrTown}, {address.selectedState},
                </span>
                <span className="text-sm">{address.landmark},</span>
                <span className="text-sm">{address.postalCode}</span>
              </div>
            </div>
          ))}

          {addresses.length > 2 && (
            <button
              onClick={toggleShowAllAddresses}
              className="text-blue-500 text-sm hover:text-blue-700"
            >
              {showAllAddresses ? 'Show Less' : 'Show All'}
            </button>
          )}
        </div>
      ) : (
        <p className="text-gray-600">No addresses saved yet. Please add a new address.</p>
      )}
    </div>
  );
}

export default Address;
